import { render, staticRenderFns } from "./OtherInformation.vue?vue&type=template&id=220fa011&scoped=true"
import script from "./OtherInformation.vue?vue&type=script&lang=js"
export * from "./OtherInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220fa011",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('220fa011')) {
      api.createRecord('220fa011', component.options)
    } else {
      api.reload('220fa011', component.options)
    }
    module.hot.accept("./OtherInformation.vue?vue&type=template&id=220fa011&scoped=true", function () {
      api.rerender('220fa011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/cmp/OtherInformation.vue"
export default component.exports